import {
    Component, OnInit, Input, OnDestroy
} from '@angular/core';
import { DataService } from 'app/services/data.service';
import { ProjectManagementService } from 'app/services/project-management.service';
import {Page} from "../../model/page";
import {Observable} from "rxjs";
import {LogService} from "../../services/log.service";

@Component({
    selector: 'app-project-attachments-tab',
    templateUrl: './project-attachments-tab.component.html',
    styleUrls: ['./project-attachments-tab.component.scss']
})
export class ProjectAttachmentsTabComponent implements OnInit, OnDestroy {

    is_icon_view = false;
    page = new Page();
    timer_subscription: any;

    // Timer every 30 secs.
    timer = Observable.timer(0, 30000);
    filesLoaded = false;

    @Input() users = {};
    @Input() usersLoaded = false;
    @Input() download_file = function () {};
    @Input() deleteFile = function () {};

    constructor(
        public dataService: DataService,
        private project_management_service: ProjectManagementService,
        private logService: LogService
    ) {
        this.page.pageNumber = 0;
        this.page.size = 10;
        this.page.totalElements = this.dataService.wall_files_list.length;
        this.page.totalPages = 0;
    }

    ngOnInit() {
        this.timer_subscription = this.timer.subscribe(() => {
            if (this.dataService.selected_project !== 0) {
                this.files_get(this.dataService.selected_project, this.dataService.wall_files_limit, 0);
            }
        });
    }

    ngOnDestroy() {
        this.timer_subscription.unsubscribe();
    }

    switch_view(view_type) {
        switch (view_type) {
            case 'folder_view':
                this.is_icon_view = false;
                break;

            case 'icon_view':
                this.is_icon_view = true;
                break;
        }
    }

    /**
     * Get files
     * @param project_id
     * @param limit - Limit is not used for files
     * @param offset
     */
    files_get(
        project_id,
        limit,
        offset
    ) {
        if (this.dataService.files_waiting_for_response) {
            // Stops further http requests until last req. gives ans
        } else {
            this.dataService.files_waiting_for_response = true;
            this.project_management_service.files_get(project_id, this.dataService.wall_files_count, offset, (resp) => {
                this.dataService.files_waiting_for_response = false;
                if (resp.status) {

                    this.logService.printLog("Got Project Files controller callback");

                    // Add files in the list
                    this.dataService.wall_files_list = this.dataService.sort_this(
                        resp.data,
                        "id"
                    );

                    this.dataService.wall_files_count = resp.count;
                    this.filesLoaded = true;
                } else {
                    this.logService.printLog("Failed Project Files controller callback");
                }
            });
        }
    }
}
